let statusList = {
    started: {
        label: 'Task started',
        variant: 'success',
        icon: 'fe-play-circle'
    },
    completed: {
        label: 'Completed',
        variant: 'success',
        icon: 'fe-check-circle'
    },
    new: {
        label: 'New',
        variant: 'primary',
        icon: 'fe-circle'
    },
    cancelled: {
        label: 'Cancelled',
        variant: 'danger',
        icon: 'fe-x-circle'
    }

};
export {
    statusList
};
export default function (status) {
    let statused;

    if (statusList[status]) {
        statused = statusList[status];
    } else {
        statused = {
            label: status
        }
    }

    return statused;
};
